import { createFileRoute } from "@tanstack/react-router";
import { AmyChat } from "@/components/AmyChat";
import amyAvatar from "@/assets/amy-avatar.jpg";

export const Route = createFileRoute("/ask-amy")({
  head: () => ({
    meta: [
      { title: "Ask Amy — AI Sales Assistant | Vending Machine Free.com" },
      {
        name: "description",
        content:
          "Chat with Amy, the AI sales assistant for Vending Machine Free.com. Get instant answers about free vending machine placement across the USA — or leave your details for a human callback within 24 hours.",
      },
      {
        property: "og:title",
        content: "Ask Amy — AI Sales Assistant | Vending Machine Free.com",
      },
      {
        property: "og:description",
        content:
          "Instant answers about free vending machine placement. Ask Amy about machine types, coverage, and next steps — real human follow-up within 24 hours.",
      },
      { name: "robots", content: "index,follow" },
    ],
  }),
  component: AskAmyPage,
});

function AskAmyPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-3xl px-4 pt-10 pb-6 sm:pt-16">
        <div className="flex items-start gap-4 sm:items-center">
          <img
            src={amyAvatar}
            alt="Amy, AI sales assistant for Vending Machine Free"
            width={96}
            height={96}
            className="h-20 w-20 shrink-0 rounded-full object-cover shadow-md ring-4 ring-[#2F5D8A]/15 sm:h-24 sm:w-24"
          />
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-[#F57C00]">
              Chat live
            </p>
            <h1 className="mt-1 text-3xl font-bold text-foreground sm:text-4xl">
              Meet Amy
            </h1>
            <p className="mt-1 text-sm text-muted-foreground">
              AI Sales Assistant · Vending Machine Free
            </p>
          </div>
        </div>
        <p className="mt-5 max-w-2xl text-sm text-muted-foreground sm:text-base">
          Ask Amy about free vending machine placement, machine types, coverage
          in your state, or the application process. When you're ready, she'll
          capture your details and hand you straight to our human team — you'll
          get a call within 24 hours.
        </p>
      </div>
      <div className="mx-auto max-w-3xl px-4 pb-16">
        <div className="overflow-hidden rounded-2xl border border-border bg-background shadow-md">
          <AmyChat variant="page" />
        </div>
      </div>
    </div>
  );
}
